import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	MEDIUM: 'medium',
	STANDARD: 'standard',
};
export const NewTabIcon = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '12';
			case SIZE.MEDIUM:
				return '16';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '12';
			case SIZE.MEDIUM:
				return '16';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg width={getWidth(size)} height={getHeight(size)} viewBox="0 0 24 24">
				<path
					d="M11.0759 12.8501C10.8416 12.6158 10.8416 12.2359 11.0759 12.0016L18.4687 4.60882L14.6997 4.60883C14.3684 4.60883 14.0997 4.3402 14.0997 4.00883C14.0997 3.67746 14.3684 3.40883 14.6997 3.40883L19.9172 3.40881C20.0764 3.40881 20.229 3.47203 20.3415 3.58455C20.454 3.69707 20.5172 3.84969 20.5172 4.00882L20.5172 9.18088C20.5172 9.51225 20.2486 9.78088 19.9172 9.78088C19.5858 9.78087 19.3172 9.51224 19.3172 9.18087L19.3172 5.45733L11.9244 12.8501C11.6901 13.0845 11.3102 13.0845 11.0759 12.8501Z"
					fill={color}
				/>
				<path
					d="M4.60002 7.40002C4.60002 6.40591 5.40591 5.60002 6.40002 5.60002H9.76253C10.0939 5.60002 10.3625 5.3314 10.3625 5.00002C10.3625 4.66865 10.0939 4.40002 9.76253 4.40002H6.40002C4.74317 4.40002 3.40002 5.74317 3.40002 7.40002V17.6C3.40002 19.2569 4.74317 20.6 6.40002 20.6H16.6C18.2569 20.6 19.6 19.2569 19.6 17.6V14.2375C19.6 13.9062 19.3314 13.6375 19 13.6375C18.6687 13.6375 18.4 13.9062 18.4 14.2375V17.6C18.4 18.5941 17.5941 19.4 16.6 19.4H6.40002C5.40591 19.4 4.60002 18.5941 4.60002 17.6V7.40002Z"
					fill={color}
				/>
			</svg>
		</StyledSpan>
	);
};

NewTabIcon.SIZE = SIZE;
NewTabIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.MEDIUM, SIZE.STANDARD]),
};

const StyledSpan = Styled.span`
	display: inline;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
